"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;

var _MemoizeKeyError = _interopRequireDefault(require("./MemoizeKeyError"));

function _interopRequireDefault(obj) {
  return obj && obj.__esModule ? obj : {
    "default": obj
  };
}

function _classCallCheck(instance, Constructor) {
  if (!(instance instanceof Constructor)) {
    throw new TypeError("Cannot call a class as a function");
  }
}

function _defineProperties(target, props) {
  for (var i = 0; i < props.length; i++) {
    var descriptor = props[i];
    descriptor.enumerable = descriptor.enumerable || false;
    descriptor.configurable = true;
    if ("value" in descriptor) descriptor.writable = true;
    Object.defineProperty(target, descriptor.key, descriptor);
  }
}

function _createClass(Constructor, protoProps, staticProps) {
  if (protoProps) _defineProperties(Constructor.prototype, protoProps);
  if (staticProps) _defineProperties(Constructor, staticProps);
  Object.defineProperty(Constructor, "prototype", {
    writable: false
  });
  return Constructor;
}

function _defineProperty(obj, key, value) {
  if (key in obj) {
    Object.defineProperty(obj, key, {
      value: value,
      enumerable: true,
      configurable: true,
      writable: true
    });
  } else {
    obj[key] = value;
  }

  return obj;
}
/**
 * To initialize, run `const memoize = new Memoize()`
 * To set, run `memoize.set([key], value)` (note that you must always pass an array)
 * To get, run `memoize.get([key])` (note that you must always pass an array)
 */


var allKeysMatch = function allKeysMatch(keys1, keys2) {
  return keys1.length === keys2.length && keys1.every(function (key, i) {
    return key === keys2[i];
  });
};

var validateKeys = function validateKeys(keys) {
  if (!keys || !Array.isArray(keys)) {
    throw new _MemoizeKeyError["default"]('Keys must be an array and is required');
  }
};

var Memoize = /*#__PURE__*/function () {
  function Memoize() {
    var options = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};

    _classCallCheck(this, Memoize);

    _defineProperty(this, "memoizedItems", []);

    _defineProperty(this, "maxItems", Infinity);

    var max = options.max;

    if (max) {
      this.maxItems = max;
    }
  }

  _createClass(Memoize, [{
    key: "getIndexOfObject",
    value: function getIndexOfObject(keysToQuery) {
      return this.memoizedItems.findIndex(function (_ref) {
        var keys = _ref.keys;
        return allKeysMatch(keysToQuery, keys);
      });
    }
  }, {
    key: "deleteObjectByKeyIfExists",
    value: function deleteObjectByKeyIfExists(keysToQuery) {
      var indexOfFoundObject = this.getIndexOfObject(keysToQuery);

      if (indexOfFoundObject === -1) {
        return;
      }

      this.memoizedItems.splice(indexOfFoundObject, 1);
    }
  }, {
    key: "set",
    value: function set(keys, value) {
      validateKeys(keys);
      this.deleteObjectByKeyIfExists(keys);

      if (this.memoizedItems.length >= this.maxItems) {
        // TODO: Create an LRU policy - for now always remove oldest item
        this.memoizedItems.splice(0, 1);
      }

      this.memoizedItems.push({
        keys: keys,
        value: value
      });
    }
  }, {
    key: "get",
    value: function get(keysToQuery) {
      validateKeys(keysToQuery);
      var indexOfFoundObject = this.getIndexOfObject(keysToQuery);

      if (indexOfFoundObject === -1) {
        return undefined;
      }

      return this.memoizedItems[indexOfFoundObject].value;
    }
  }]);

  return Memoize;
}();

_defineProperty(Memoize, "KeyError", _MemoizeKeyError["default"]);

var _default = Memoize;
exports["default"] = _default;